import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import MultiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';
import {
  MultiChannelOrderItemExcelDownloadRequestDto,
  MultiChannelOrderItemExcelDownloadResponseDto,
} from '../../../types/api/multi-channels';

const useDownloadExcelFile = (): UseMutationResult<
  MultiChannelOrderItemExcelDownloadResponseDto,
  AxiosError,
  MultiChannelOrderItemExcelDownloadRequestDto
> => {
  return useMutation<
    MultiChannelOrderItemExcelDownloadResponseDto,
    AxiosError,
    MultiChannelOrderItemExcelDownloadRequestDto
  >((payload: MultiChannelOrderItemExcelDownloadRequestDto) => MultiChannelApi.downloadExcelFile(payload));
};

export default useDownloadExcelFile;
